import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';
import { Button } from './ui/button';

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      setIsMobileMenuOpen(false);
    }
  };

  const menuItems = [
    { label: 'Beranda', id: 'beranda' },
    { label: 'Layanan', id: 'layanan' },
    { label: 'Pengalaman', id: 'pengalaman' },
    { label: 'Portofolio', id: 'portofolio' },
    /*{ label: 'Testimoni', id: 'testimoni' },*/
    { label: 'Kontak', id: 'kontak' }
  ];

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        isScrolled
          ? 'bg-white shadow-md py-4'
          : 'bg-transparent py-6'
      }`}
    >
      <div className="container mx-auto px-4 lg:px-8">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <div
            className="cursor-pointer"
            onClick={() => scrollToSection('beranda')}
          >
            <h1
              className={`text-2xl lg:text-3xl font-fraunces font-bold transition-colors duration-300 ${
                isScrolled ? 'text-[#00382F]' : 'text-white'
              }`}
            >
              Mobius Stories
            </h1>
          </div>

          {/* Desktop Menu */}
          <div className="hidden lg:flex items-center space-x-8">
            {menuItems.map((item) => (
              <button
                key={item.id}
                onClick={() => scrollToSection(item.id)}
                className={`transition-colors duration-300 font-lato font-medium ${
                  isScrolled
                    ? 'text-[#00382F] hover:text-[#658C8D]'
                    : 'text-white hover:text-[#C1CCBC]'
                }`}
              >
                {item.label}
              </button>
            ))}
          </div>

          {/* Mobile Menu Button */}
          <button
            className={`lg:hidden transition-colors duration-300 ${
              isScrolled ? 'text-[#00382F]' : 'text-white'
            }`}
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            {isMobileMenuOpen ? <X size={28} /> : <Menu size={28} />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="lg:hidden mt-6 pb-4 animate-in slide-in-from-top duration-300">
            <div className="flex flex-col space-y-4">
              {menuItems.map((item) => (
                <button
                  key={item.id}
                  onClick={() => scrollToSection(item.id)}
                  className={`transition-colors duration-300 font-lato font-medium text-left py-2 border-b last:border-b-0 ${
                    isScrolled
                      ? 'text-[#00382F] border-[#C1CCBC] hover:text-[#658C8D]'
                      : 'text-white border-white/30 hover:text-[#C1CCBC]'
                  }`}
                >
                  {item.label}
                </button>
              ))}
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;